var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDamagedProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.337 4.16418H41.6653L0 45.833V75.2585L200 80.9465V45.833L158.337 4.16418Z",
    fill: "#F6BB42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.162 195.836H0V45.833H200V149.999L154.162 195.836Z",
    fill: "#FFCE54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.662 4.16418H83.3341L74.9999 54.1645H125L116.662 4.16418Z",
    fill: "#E6E9ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125 83.3329L116.662 87.4959L108.337 83.3329L99.9998 87.4959L91.6656 83.3329L83.3341 87.4959L74.9999 83.3329V45.833H125V83.3329Z",
    fill: "#F5F7FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4999 154.161H20.8342C18.533 154.161 16.6653 156.029 16.6653 158.336C16.6653 160.631 18.533 162.499 20.8342 162.499H62.4999C64.8011 162.499 66.6652 160.631 66.6652 158.336C66.6652 156.029 64.8011 154.161 62.4999 154.161Z",
    fill: "#434A54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6653 170.836H20.8342C18.533 170.836 16.6653 172.691 16.6653 174.998C16.6653 177.293 18.533 179.161 20.8342 179.161H41.6653C43.9665 179.161 45.8342 177.293 45.8342 174.998C45.8342 172.691 43.9665 170.836 41.6653 170.836Z",
    fill: "#434A54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 149.834C108 124.517 128.52 104 153.825 104C179.143 104 199.663 124.517 199.663 149.834C199.663 175.152 179.143 195.671 153.825 195.671C128.52 195.671 108 175.152 108 149.834Z",
    fill: "#ED5564"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.655 130.057L135.017 166.32C133.269 168.322 133.672 171.537 135.922 173.5C138.16 175.452 141.399 175.416 143.147 173.413L174.785 137.15C176.533 135.147 176.127 131.936 173.889 129.983C171.64 128.02 168.403 128.054 166.655 130.057Z",
    fill: "#434A54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.065 137.08L166.577 173.454C168.317 175.463 171.556 175.511 173.813 173.555C176.058 171.611 176.472 168.398 174.731 166.389L143.22 130.016C141.48 128.007 138.243 127.962 135.999 129.906C133.742 131.861 133.325 135.071 135.065 137.08Z",
    fill: "#434A54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamagedProduct);
export default __webpack_public_path__ + "static/media/damaged-product.baa71532.svg";
export { ForwardRef as ReactComponent };